<template>
  <div class="content-contrainer">
    <div class="content-banner" :class="__lang"></div>
    <div class="content-menu-list">
      <div class="main-box">
        <router-link v-for="(item, index) in childrenMenu.child" :key="index" :to="item.link" class="content-menu-list-item" active-class="active">{{item.name}}</router-link>
      </div>
    </div>
    <html404 v-if="content===null"></html404>
    <div v-else>
      <block :title="lang[__lang][routeName]">
        <div class="main-box" style="margin-top: 50px;">
          <div class="st-desc">
            <el-image
              :src="content.img1"
              fit="cover"
            ></el-image>
            <div class="text1-box" :class="__lang+'-'+routeName">
              <div class="icon">
                <el-image
                  :src="content.icon1"
                  fit="cover"
                ></el-image>
              </div>
              <p>{{content.text1}}</p>
              <span class="vertical"></span>
            </div>
          </div>
          
          <div class="databox data1 text-center">
            <el-image
              style="width:1000px;"
              :src="content.data1.thumb"
              fit="cover"
            ></el-image>
          </div>
          <el-divider></el-divider>
          <div class="labor-checkbox">
            <el-row :gutter="20">
              <el-col :span="__span" v-for="(item, index) in content.serveic" :key="index">
                <a href="javascript:;" @click="checkLabor(index)" :class="'labor-checkbox-btn '+(index===active?'active':'')">
                  <el-image
                    class="icon icon1"
                    :src="item.icon1"
                    fit="contain"
                  ></el-image>
                  <el-image
                    class="icon icon2"
                    :src="item.icon2"
                    fit="contain"
                  ></el-image>
                  <span style="display: inline-block;vertical-align: middle;height: 100%;">{{item.name}}</span>
                </a>
              </el-col>
            </el-row>
          </div>
          <div class="datacontent" v-html="content.serveic[active].content"></div>
        </div>
      </block>
    </div>
  </div>
</template>

<script>
import { navbar, product as data } from "../../data.js";
import lang from "../../lang.js";
import block from "../../components/block.vue";
import html404 from "../../components/404.vue";
export default {
  name: "smartTransportation",
  components:{
    block,
    html404
  },
  data() {
    return {
      lang,
      data,
      active:0
    };
  },
  watch:{
    "$route":function(r1, r2){
      if (r1.name!==r2.name) {
        this.active = 0;
      }
    }
  },
  computed:{
    menus(){
      return navbar({
        lang:this.$route.params.lang || 'zh-CN'
      })
    },
    __span(){
      return Math.floor(24/this.content.serveic.length);
    },
    childrenMenu(){
      return this.menus.find(v=>v.id=="product");
    },
    __lang(){return this.$route.params.lang},
    content(){
      const lang = this.__lang;
      const name = this.$route.name;
      return data[lang][name]||null;
    },
    routeName(){
      return this.$route.name;
    }
  },
  methods:{
    checkLabor(index) {
      this.active = index;
    }
  },
  created(){
    console.log(this.$route.name, this.content);
  }
};
</script>

<style lang="less" scoped>
.content-contrainer {
  padding-bottom: 60px;
}
.content-banner {
  margin-top: 70px;
  width: 100%;
  height: 340px;
  background: url(../../assets/img/banner_yewu.jpg) center center no-repeat;
  &.en {
    background: url(../../assets/img/banner_yewu_en.png) center center no-repeat;
  }
}
.content-menu-list {
  border-bottom: 1px solid #999;
  overflow: hidden;
  .content-menu-list-item {
    text-decoration: none;
    color: #222;
    float: left;
    line-height: 60px;
    font-size: 16px;
    padding: 0 20px;
    &.active{
      color: #d22c1d;
    }
    &.active:after {
      display: block;
      content: " ";
      width: 60%;
      height: 4px;
      background-color: #d22c1d;
      margin: auto;
    }
  }
}
.filed-desc {
  padding: 40px 0;
  line-height: 30px;
  font-size: 18px;
}
.labor-checkbox {
  margin-bottom: 40px;
  .labor-checkbox-btn {
    display:block;
    width: 100%;
    text-align: center;
    line-height: 60px;
    height: 60px;
    padding: 0;
    background-color: #eee;
    color: #222;
    text-decoration: none;
    border-radius: 0;
    font-size: 18px;
    .icon {
      width: 36px;
      display: inline-block;
      height: 100%;
      vertical-align:
      middle;margin-right: 10px;
    }
    .icon1 {
      display: none;
    }
    .icon2{
      display: inline-block;
    }
    &.active{
      color: #fff;
      background-color: #d22c1d;
      .icon2 {
        display: none;
      }
      .icon1{
        display: inline-block;
      }
    }
  }
}
.st-desc {
  position: relative;
  .text1-box {
    position: absolute;
    top: 0;
    left: 130px;
    right: 143px;
    margin: 100px auto;
    height: 130px;
    &.en-smartPark {
      margin: 102px auto;
      p {
        width: 700px;
        line-height: 1.5;
      }
    }
    &.en-cityService{
      p {
        width: 715px;
        line-height: 1.7
      }
    }
    .icon{
      // margin-top: 20px;
      // margin-left: 100px;
      // margin-right: 50px;
      display: inline-block;
      vertical-align: middle;
      width: 80px;
      margin-left:80px;
    }
    span.vertical{
      display: inline-block;
      height: 100%;
      vertical-align: middle;
    }
    p{
      color: #fff;
      margin:0;
      padding:0;
      line-height: 1.8;
      display: inline-block;
      vertical-align: middle;
      width: 660px;
      margin-left: 40px;
      margin-top: -10px;
    }
  }
}
.databox {
  margin-top: 20px;
}
.datacontent {
  img{
    width: 100%;
  }
}
</style>
